import { Component } from '@angular/core';
import { ConfigService } from 'src/app/services/config/config.service';
import { AboutUsPageConfig } from 'src/app/interfaces/pageConfig';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent {
  public page: AboutUsPageConfig;

  constructor(private configService: ConfigService) {
    this.page = this.configService.getPage('aboutUs');
  }
}
